var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"section__about"},[_c('about-hero'),_vm._v(" "),_c('timeline-item'),_vm._v(" "),_c('about-mission')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }